/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Views_ResetInputs */

const en_views_reset = /** @type {(inputs: Views_ResetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reset ${i?.name} to its saved state`)
};

const de_views_reset = /** @type {(inputs: Views_ResetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} auf den gespeicherten Stand zurücksetzen`)
};

/**
* | output |
* | --- |
* | "Reset {name} to its saved state" |
*
* @param {Views_ResetInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const views_reset = /** @type {((inputs: Views_ResetInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Views_ResetInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_views_reset(inputs)
	return en_views_reset(inputs)
});